import ReactDynamicFont from "react-dynamic-font";
import { FiInfo } from "react-icons/fi";
import { Skeleton } from "@mui/material";
import { DashboardTooltip } from "../DashboardTooltip";
import { LockedFeatureIcon } from "../../../../components/LockedFeatureIcon";
import {
  CardValue,
  IconContainer,
  Info,
  MiniCardBox,
  MiniHeader,
  ContentWrapper,
  HeaderContent,
} from "./styles";

interface NumberCardProperties {
  icon: React.ReactNode;
  title: string;
  value: number | string;
  hasAditionalInfo?: boolean;
  aditionalInfo?: string;
  isLoading?: boolean;
  isLocked?: boolean;
  lockedLabel?: string;
}

export function NumberCardBox({
  icon,
  title,
  value,
  hasAditionalInfo = false,
  aditionalInfo,
  isLoading = false,
  isLocked = false,
  lockedLabel = "Desbloqueie tornando-se um Licenciado",
}: NumberCardProperties) {
  return (
    <MiniCardBox $isLocked={isLocked} style={{ position: "relative", overflow: "hidden" }}>
      {isLocked && <LockedFeatureIcon title={lockedLabel} withOverlay />}

      <IconContainer style={{
        filter: isLocked ? "blur(3px)" : "none",
        opacity: isLocked ? 0.35 : 1,
        userSelect: isLocked ? "none" : "auto",
      }}>
        {icon}
      </IconContainer>
      
      <ContentWrapper>
        <HeaderContent>
          <MiniHeader>{title}</MiniHeader>
          {!isLocked && hasAditionalInfo && (
            <DashboardTooltip title={aditionalInfo || ""} placement="top">
              <Info display={hasAditionalInfo}>
                <FiInfo />
              </Info>
            </DashboardTooltip>
          )}
        </HeaderContent>
        <CardValue style={{
          filter: isLocked ? "blur(4px)" : "none",
          opacity: isLocked ? 0.35 : 1,
          userSelect: isLocked ? "none" : "auto",
        }}>
          {isLoading ? (
            <Skeleton variant="text" width="60%" height={32} />
          ) : (
            <ReactDynamicFont content={value.toString()} />
          )}
        </CardValue>
      </ContentWrapper>
    </MiniCardBox>
  );
}
